import moment from "moment";
import {
  getBitcoinMainInfo,
  getBitcoinTableData,
  getBitcoinOutputs,
} from "./bitcoin";
import { getTronMainInfo, getTronTableData } from "./tron";
import { getUsdtMainInfo, getUsdtTableData } from "./usdt";
import { getTonMainInfo, getTonTableData } from "./ton";
import { getEthMainInfo, getEthTableData } from "./ethereum";

export function formatNumberByThousands(num) {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const getSymbol = (network) => {
  switch (network) {
    case "bitcoin":
      return "BTC";
    case "tron":
      return "TRX";
    case "usdt":
      return "USDT";
    case "ton":
      return "TON";
    case "ethereum":
      return "ETH";
    default:
      return "";
  }
};

const truncateTo2 = (num) => Math.trunc(num * 100) / 100;

export const formatFiat = (value) =>
  value ? `$\u202F${truncateTo2(Number(value))}` : "";

const getMainInfo = (network, transaction) => {
  switch (network) {
    case "bitcoin":
      return getBitcoinMainInfo(transaction);
    case "tron":
      return getTronMainInfo(transaction);
    case "usdt":
      return getUsdtMainInfo(transaction);
    case "ton":
      return getTonMainInfo(transaction);
    case "ethereum":
      return getEthMainInfo(transaction);
    default:
      return {};
  }
};

export const getAge = (timestamp) => {
  // Explicitly parse as UTC
  const start = moment.utc(timestamp);
  // Use moment.utc() for current time as well for consistent comparison
  const now = moment.utc();

  // Check if the date is valid after parsing
  if (!start.isValid()) {
    console.error("Moment could not parse timestamp:", timestamp);
    return "Invalid Date";
  }

  const totalMinutes = now.diff(start, "minutes");
  const totalHours = now.diff(start, "hours");
  const totalDays = now.diff(start, "days");
  const totalYears = now.diff(start, "years");

  // До 10 минут - показываются минуты с секундами в лайве
  if (totalMinutes < 10) {
    const seconds = now.diff(start, "seconds") % 60;
    return `${totalMinutes}m ${seconds}s`;
  }

  // До 60 минут, показываются только минуты
  if (totalMinutes < 60) {
    return `${totalMinutes}m`;
  }

  // Более 60 минут — минуты, часы
  if (totalHours < 24) {
    const hours = Math.floor(totalHours);
    const minutes = totalMinutes % 60;
    return `${hours}h ${minutes}m`;
  }

  // Более 1 дня — только дни
  if (totalDays < 365) {
    return `${totalDays}d`;
  }

  // Более 365 дней — только года и дни
  const years = Math.floor(totalYears);
  const remainingDays = totalDays % 365;
  return `${years}y ${remainingDays}d`;
};

const getTableData = (network, transaction) => {
  switch (network) {
    case "bitcoin":
      return getBitcoinTableData(transaction);
    case "tron":
      return getTronTableData(transaction);
    case "usdt":
      return getUsdtTableData(transaction);
    case "ton":
      return getTonTableData(transaction);
    case "ethereum":
      return getEthTableData(transaction);
    default:
      return [];
  }
};

export function transactionFormatter(transaction) {
  const { block, hash, network, details } = transaction;

  // For header
  const header = {
    date: block?.timestamp || "Unloaded timestamp",
    copyValue: hash,
  };
  console.log(header, "header");

  // For rate banner
  const rate = {
    value: 0,
    symbol: getSymbol(network),
  };
  console.log(rate, "rate");

  const mainInfo = getMainInfo(network, transaction);
  console.log(mainInfo, "mainInfo");
  const tableData = getTableData(network, transaction);
  console.log(tableData, "tableData");
  let result = { header, rate, mainInfo, tableData, block }; // Добавляем block в результат
  console.log(result, "result");
  // for btc transaction details
  if (network === "bitcoin") {
    return getBitcoinOutputs(details, result);
  }

  return result;
}
